module.exports = __webpack_public_path__ + "img/dpng.fd21e5a8.svg";